export default "__VITE_ASSET__C9q_OEsA__"